import { JSX } from "react";

import { Alert } from "@mui/material";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import { SubstructureElementLayout } from "@plansoft-configuration-renderer/components";
import { ConfigurationObject } from "@plansoft-configuration-renderer/configuration-api";
import { useCsAttribute } from "@plansoft-configuration-renderer/framework";

import { CustomSubstructureInstanceButtons } from "./CustomSubstructureInstanceButtons";
import { SubstructureDialog } from "./SubstructureDialog";

export function CustomSubstructureStubAsButton({
  iconKey,
  awaitFunction,
}: {
  iconKey?: string;
  awaitFunction?: string;
}): JSX.Element {
  const attribute = useCsAttribute();
  const substructures: ConfigurationObject[] = attribute.configurations ?? [];

  return (
    <SubstructureElementLayout
      addButton={
        attribute?.configurations?.length === 0 ? (
          <Box>
            <Alert severity="error">
              Substructure is not initialized, please add one instance in the
              configuration logic
            </Alert>
          </Box>
        ) : (
          <></>
        )
      }
      instanceList={
        <List sx={{ display: "flex", flexDirection: "column", gap: 1, pb: 0 }}>
          {substructures.map((substructure, idx) => (
            <Box key={idx} sx={{ display: "flex", gap: 1 }}>
              <SubstructureDialog
                substructure={substructure}
                iconKey={iconKey}
                awaitFunction={awaitFunction}
              />
              <CustomSubstructureInstanceButtons substructure={substructure} />
            </Box>
          ))}
        </List>
      }
    />
  );
}

CustomSubstructureStubAsButton.displayName = "SubstructureStub";
